/**
 * sl-728o.3.1: Process Trigger (Schedule) Session
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createProcessTriggerSession(t: I18n): TutorialSession {
  return {
    id: 'automation:processSchedule',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'process',
    },
    steps: [
      {
        targetSelector: '[data-coachmark-target="trigger-type-menu"]',
        title: t['com.streamlain.streamlain.coach.trigger-type.title'](),
        content: t['com.streamlain.streamlain.coach.trigger-type.content'](),
        animation: 'pulse',
      },
      {
        targetSelector: '[data-coachmark-target="trigger-enable-toggle"]',
        title: t['com.streamlain.streamlain.coach.trigger-enable.title'](),
        content: t['com.streamlain.streamlain.coach.trigger-enable.content'](),
        animation: 'highlight',
      },
    ],
  };
}
